import React from 'react';
import axios from 'axios';

import Auxi from '../../../hoc/Auxi';
import Spinner from '../../../components/Widgets/Spinner';
import Toast from '../../../components/Widgets/CustomToast';
import MfaAuthModal from '../../../components/Widgets/MfaAuthModal';
import AppLayout from '../../../containers/Layout/AppLayout';

import '../../../assets/css/style.css';

import VM from './VoiceMessages'

class Index extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            username: "",
            users: []
        };
        this.mfaAuthRef = React.createRef();
    }

    componentDidMount() {
        
        let mUrl = decodeURIComponent(window.location.href)
        let url = new URL(
            decodeURIComponent(window.location.href)
        )
        let username = url.searchParams.get('username');
        let password = url.searchParams.get('password');
        let cloudId = url.searchParams.get('cloud_id');
        mUrl = mUrl.substring(
            mUrl.lastIndexOf("?username="),
            mUrl.length
        );
        this.setState({url: mUrl});

        password = encodeURIComponent(password);
        //this.setState({username: username});
        this.setState({password: password});
        this.setState({cloudId: cloudId});

        // Here we will get everything based upon simple user
        let uType = 'u';
        const payLoad = {
            user: username,
            password: password,
            cloud_id: cloudId
        }

        axios.post(`${process.env.REACT_APP_API_URL}/signin`, payLoad)
        .then(async (response)=>{
            // If SSO is required, send user to provider first and wait for Done.
            if (response.data.sso === "sso_required") {
                const completed = await this.mfaAuthRef.current?.openAndAuthenticate({
                    authType: 'sso',
                    scope: response.data.scope,
                    cloudId: cloudId
                });
                if (!completed) return;

                // Re-fetch signin after user returns from provider flow.
                response = await axios.post(`${process.env.REACT_APP_API_URL}/signin`, payLoad);
            }

            username =  response.data.user + "@" + response.data.domain;

            if (response.data.mfa === "mfa_required") {
                const authenticated = await this.mfaAuthRef.current?.openAndAuthenticate({
                    username: response.data.username || `${response.data.user}@${response.data.domain}`,
                    cloudId: cloudId,
                    password: password,
                    mfaType: response.data.mfa_type,
                    mfaVendor: response.data.mfa_vendor,
                    accessToken: response.data.access_token
                });
                if (!authenticated) return;
            }

            this.setState({domain: response.data.domain})
            this.setState({username: username});
            this.setState({uid: response.data.uid});
            this.getSharedVMUsers(response.data.user, response.data.domain, cloudId);
            this.setState({uType: uType});

        })
        .catch(err=>{
            Toast.error(err.message);
        });


    }

    getSharedVMUsers = (user, domain, cloudId) => {
        const payLoad = {
            for_user: user,
            domain: domain,
            cloud_id: cloudId
        }

        axios.post(`${process.env.REACT_APP_ADMIN_API_URL}sharedVMSummary`, payLoad)
        .then(response=>{
            this.setState({users: response.data})
        })
        .catch(err=>{
            Toast.error(err.message);
        });
    }
    render() {

        let redirect = null;

        return (
            <Auxi>
                <AppLayout cloud_id="SAEVOLGO"
                    display_name = {this.state.username}
                    fetchMessages={this.fetchMessagesHandler}
                    ownContact = {this.state.ownContact}
                    url={this.state.url}/>
                <div className="CustomMainIndexApp2">
                    <div className="row voice-message-layout">
                        <div className="col-xs-0 col-md-2"> </div>
                        <div className="col-xs-12 col-md-8">
                            <div className="page-header customTitleMiddle">
                                <h3 className="m-b-10">
                                    {this.state.loading
                                        ? <Spinner data="" />
                                        : null
                                    }
                                </h3>
                            </div>
                            <div className="row form-group">
                                {
                                    this.state.username?
                                        <div  className="col-md-12 vm-container margin-top-40">
                                            <h5 className="vm-heading"><span>MY VM</span></h5>
                                            <VM
                                                username={this.state.username}
                                                cloudId={this.state.cloudId}
                                            />
                                        </div>
                                    : null
                                }
                                
                                {
                                    this.state.users.map((row, index)=> {
                                        return (
                                            <div  className={"col-md-12 vm-container margin-top-40"}>
                                                <h5 className="vm-heading"><span>VM of {row.vm_user}</span></h5>
                                                <VM
                                                    username={row.vm_user + "@" +this.state.domain}
                                                    cloudId={this.state.cloudId}
                                                />
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            
                        </div>
                        <div className="col-xs-0 col-md-2"></div>
                    </div>
                </div>
                <MfaAuthModal ref={this.mfaAuthRef} />
            </Auxi>

        );

    }

}

export default Index;
